
import React, {useEffect, useState} from "react";
import FormGroup from "../../elements/formElements/FormGroup";
import Select from "../../elements/formElements/Select";
import FormFileGroup from "../../elements/formElements/FormFileGroup";
import axios from '../../services/MyAxios';

function PaymentMethodChannelForm({action, paymentMethodChannelData, errors}) {
    const [paymentMethods, setPaymentMethods] = useState([]);
    const [paymentMethodChannel, setPaymentMethodChannel] = useState({
        name: '',
        payment_method_id: '',
        logo: '',
        order: '',
    });
    const paymentMethodsUrl = "/crea/api/payment_method/names"

    useEffect(() => {
        axios.get(paymentMethodsUrl).then((response) => {
            setPaymentMethods(response.data);
        });
    }, []);

    useEffect(() => {
        if (paymentMethodChannelData) {
            setPaymentMethodChannel({
                ...paymentMethodChannel,
                name: paymentMethodChannelData.name,
                payment_method_id: paymentMethodChannelData.payment_method_id,
                logo_url: paymentMethodChannelData.logo_url,
                order: paymentMethodChannelData.order,
            });
        }
    }, [paymentMethodChannelData]);

    function handleSubmit(event) {
        event.preventDefault();
        action(paymentMethodChannel);
    }

    function getErrorsFor(field) {
        if (errors[field]) {
            return errors[field][0];
        }
    }

    return (
        <form
            onSubmit={handleSubmit}
            autoComplete="do-not-autofill"
            encType="multipart/form-data"
        >
            <FormGroup
                key="name"
                type="text"
                field="name"
                value={paymentMethodChannel.name}
                label="Name"
                error={getErrorsFor("name")}
                handleChange={
                    (event) => setPaymentMethodChannel({
                        ...paymentMethodChannel,
                        name: event.target.value
                    })
                }
            />

            <Select
                field="payment_method_id"
                value={paymentMethodChannel.payment_method_id}
                label="Payment Method"
                options={paymentMethods}
                error={getErrorsFor("payment_method_id")}
                handleChange={(event) => setPaymentMethodChannel({
                    ...paymentMethodChannel,
                    payment_method_id: event.target.value
                })}
            />

            <FormFileGroup
                key="logo"
                field="logo"
                value={paymentMethodChannel.logo_url}
                label="Logo Image"
                error={getErrorsFor("logo")}
                handleChange={(event) => {
                    setPaymentMethodChannel({
                    ...paymentMethodChannel,
                        logo: event.target.files[0]
                })}}
            />

            <FormGroup
                key="order"
                type="number"
                field="order"
                value={paymentMethodChannel.order}
                label="Order"
                error={getErrorsFor("order")}
                handleChange={(event) => setPaymentMethodChannel({...paymentMethodChannel, order: event.target.value})}
            />

            <div className="card-body">
                <button type="submit" className="btn btn-primary">
                    Save
                </button>
            </div>
        </form>
    );
}

export default PaymentMethodChannelForm;
